import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MovieCard from '../components/MovieCard';
import { moviesAPI } from '../api';
import { useSettings } from '../contexts/SettingsContext';

const PersonMovies = () => {
  const { name } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'director'; // director or cast
  const { settings } = useSettings();
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMovies();
  }, [name, type]);

  // Update title
  useEffect(() => {
    const roleText = type === 'director' ? 'Yönetmen' : 'Oyuncu';
    document.title = `${decodeURIComponent(name)} - ${roleText} - ${settings.site_name || 'Cinefora'}`;
  }, [name, type, settings.site_name]);

  const loadMovies = async () => {
    try {
      setLoading(true);
      const params = {};
      if (type === 'director') {
        params.director = decodeURIComponent(name);
      } else if (type === 'cast') {
        params.cast = decodeURIComponent(name);
      }
      
      const response = await moviesAPI.getAll(params);
      // Filter out archived movies
      const filteredMovies = response.data.filter(movie => movie.status !== 'archived');
      setMovies(filteredMovies);
    } catch (error) {
      console.error('Error loading movies:', error);
    } finally {
      setLoading(false);
    }
  };

  const getRoleText = () => {
    return type === 'director' ? 'Yönetmen' : 'Oyuncu';
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Helmet>
        <title>{decodeURIComponent(name)} - {getRoleText()} - {settings.site_name || 'Cinefora'}</title>
        <meta name="description" content={`${decodeURIComponent(name)} ${getRoleText().toLowerCase()} filmleri`} />
      </Helmet>
      <Header />
      
      <div className="container mx-auto px-6 py-32">
        {/* Page Header */}
        <div className="mb-12">
          <div className="inline-block bg-[#FDB714] text-black px-4 py-1 rounded-full text-sm font-semibold mb-4">
            {getRoleText()}
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {decodeURIComponent(name)}
          </h1>
          <p className="text-gray-400 text-lg">
            {movies.length} film bulundu
          </p>
        </div>

        {/* Movies Grid */}
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="text-white text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FDB714] mx-auto mb-4"></div>
              <p>Filmler yükleniyor...</p>
            </div>
          </div>
        ) : movies.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-gray-400 text-xl">
              {decodeURIComponent(name)} için film bulunamadı.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            {movies.map((movie) => (
              <MovieCard key={movie._id} movie={movie} />
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default PersonMovies;
